(()=>{
  function initialize(root){
    if(root.dataset.initialized==='true')return;
    root.dataset.initialized='true';
    const main=root.querySelector('[data-main-image]');
    const thumbs=[...root.querySelectorAll('[data-gallery-thumb]')];
    function showImage(source){
      if(!main||!source.dataset.src)return;
      main.src=source.dataset.src;
      main.removeAttribute('srcset');
      main.alt=source.dataset.alt||'';
      thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.imageId===source.dataset.imageId)));
    }
    let baseImage={dataset:{src:main?.getAttribute('src')||'',alt:main?.alt||'',imageId:thumbs.find(t=>t.getAttribute('aria-pressed')==='true')?.dataset.imageId||''}};
    const restore=()=>showImage(baseImage);
    function setBaseImage(source){
      if(!source?.dataset?.src)return;
      baseImage={dataset:{src:source.dataset.src,alt:source.dataset.alt||'',imageId:source.dataset.imageId||''}};
      restore();
    }
    thumbs.forEach(t=>t.addEventListener('click',()=>setBaseImage(t)));
    const variantSelect=root.querySelector('[data-variant-select]');
    const variants=[...variantSelect.options].map(o=>({element:o,id:o.value,...o.dataset,options:JSON.parse(o.dataset.options||'[]')}));
    const groups=[...root.querySelectorAll('[data-option-index]')];
    const images=[...root.querySelectorAll('[data-sku-image]')];
    const optionValue=g=>g.querySelector('input:checked')?.value;
    const setOptions=v=>groups.forEach((g,i)=>g.querySelectorAll('input').forEach(input=>input.checked=input.value===v.options[i]));
    const variantImage=v=>v?.imageId?images.find(img=>img.dataset.imageId===v.imageId)||thumbs.find(t=>t.dataset.imageId===v.imageId):null;
    function commit(v){
      variantSelect.disabled=!v;
      if(v)variantSelect.value=v.id;
      const price=root.querySelector('[data-product-price]');if(price)price.textContent=v?v.price:'';
      const sku=root.querySelector('[data-sku]');if(sku)sku.textContent=v?.sku||'';
      const skuWrap=root.querySelector('[data-sku-wrap]');if(skuWrap)skuWrap.hidden=!v?.sku;
      const available=v?.available==='true';
      const stock=root.querySelector('[data-stock]');if(stock)stock.textContent=available?stock.dataset.inStock:stock.dataset.soldOut;
      const add=root.querySelector('[data-add-to-cart]');if(add){add.disabled=!available;add.textContent=available?add.dataset.addLabel:add.dataset.soldLabel;}
      root.querySelector('[data-invalid-variant]').hidden=!!v;
      images.forEach(img=>img.setAttribute('aria-pressed',String(!!v&&img.dataset.imageId===v.imageId)));
      const activeImage=variantImage(v);if(activeImage)setBaseImage(activeImage);
      const url=new URL(window.location.href);if(v)url.searchParams.set('variant',v.id);else url.searchParams.delete('variant');window.history.replaceState({},'',url);
    }
    groups.forEach(g=>g.addEventListener('change',()=>{commit(variants.find(v=>groups.every((select,i)=>v.options[i]===optionValue(select))))}));
    variantSelect.addEventListener('change',()=>{const v=variants.find(x=>x.id===variantSelect.value);if(v)setOptions(v);commit(v);});
    images.forEach(img=>{
      img.addEventListener('pointerenter',e=>{if(e.pointerType!=='touch')showImage(img);});
      img.addEventListener('pointerleave',restore);
      img.addEventListener('focus',()=>showImage(img));
      img.addEventListener('blur',restore);
      img.addEventListener('click',()=>{
        const candidates=variants.filter(v=>v.imageId===img.dataset.imageId);
        candidates.sort((a,b)=>groups.reduce((sum,g,i)=>sum+Number(b.options[i]===optionValue(g))-Number(a.options[i]===optionValue(g)),0));
        const v=candidates[0];if(!v)return;
        setOptions(v);commit(v);
      });
    });
    const productForm=root.querySelector('form[action*="/cart/add"]')||root.querySelector('form');
    productForm?.addEventListener('submit',async e=>{
      if(variantSelect.disabled){e.preventDefault();return;}
      e.preventDefault();
      const add=root.querySelector('[data-add-to-cart]');
      if(add?.disabled)return;
      const normalLabel=add?.dataset.addLabel||add?.textContent||'Add to cart';
      if(add){add.disabled=true;add.textContent='Adding…';}
      try{
        const action=(productForm.action||'/cart/add').replace(/\.js(?:\?.*)?$/,'')+'.js';
        const response=await fetch(action,{
          method:'POST',
          headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:new FormData(productForm)
        });
        const data=await response.json().catch(()=>({}));
        if(!response.ok)throw new Error(data.description||data.message||'Unable to add this item.');
        document.dispatchEvent(new CustomEvent('senlo:cart:updated',{detail:{item:data,open:true}}));
      }catch(error){
        window.alert(error?.message||'Unable to add this item.');
      }finally{
        if(add){add.disabled=false;add.textContent=normalLabel;}
      }
    });
    root.addEventListener('pointerdown',e=>{if(!e.target.closest('[data-sku-image]'))restore();});
    const tabs=[...root.querySelectorAll('[data-tab]')];
    const panels=[...root.querySelectorAll('[data-panel]')];
    root.querySelector('[data-tabs]').setAttribute('role','tablist');
    function select(tab,focus=false){tabs.forEach(t=>{const active=t===tab;t.setAttribute('role','tab');t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});panels.forEach(p=>{p.setAttribute('role','tabpanel');p.tabIndex=0;p.hidden=p.dataset.panel!==tab.dataset.tab;});if(focus)tab.focus();}
    tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(t));t.addEventListener('keydown',e=>{let target;if(e.key==='ArrowRight')target=(i+1)%tabs.length;if(e.key==='ArrowLeft')target=(i+tabs.length-1)%tabs.length;if(e.key==='Home')target=0;if(e.key==='End')target=tabs.length-1;if(target!==undefined){e.preventDefault();select(tabs[target],true);}});});
    if(tabs.length)select(tabs[0]);
  }
  function scan(scope){if(scope.matches?.('[data-unified-product]'))initialize(scope);scope.querySelectorAll('[data-unified-product]').forEach(initialize);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
})();
